import type { PinData } from '../Map.types';

export function checkIfPinHasValidCoordinates(pin: PinData): boolean {
  return (
    typeof pin.lat === 'number' &&
    typeof pin.lng === 'number' &&
    !Number.isNaN(pin.lat) &&
    !Number.isNaN(pin.lng)
  );
}
